import { NgModule } from "@angular/core";
import { RadioboxFormComponent } from './radiobox-form/radiobox-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RadioboxDesignComponent } from './radiobox-design/radiobox-design.component';
import { DynamicRadioboxComponent } from './dynamic-radiobox.component';
import { RadioboxResultComponent } from './radiobox-result/radiobox-result.component';
import { KendoModule } from '../kendo.module';

@NgModule({
    declarations: [
        DynamicRadioboxComponent, RadioboxFormComponent, RadioboxDesignComponent, RadioboxResultComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        KendoModule
    ],
    entryComponents: [
        DynamicRadioboxComponent
    ]
})
export class RadioboxModule {}